<template>
  <div class="router-tab">
    <div class="tabs-header"></div>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="14">
        <div class="title">{{$t('records.title')}}{{number}}</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="4">
        <el-date-picker class="hidden-md-and-down" style="width:100%;" v-model="startDate" @change="getStartDate"
          format="yyyy-MM-dd" type="date" placeholder="START"></el-date-picker>
        <el-date-picker class="hidden-lg-and-up date-lg-up" v-model="startDate" @change="getStartDate" format="yyyy-MM-dd"
          type="date" placeholder="START" test_id="start_time"></el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="4">
        <el-date-picker class="hidden-md-and-down" style="width:100%;" v-model="endDate" @change="getEndDate" format="yyyy-MM-dd"
          type="date" placeholder="END"></el-date-picker>
        <el-date-picker class="hidden-lg-and-up date-lg-up" v-model="endDate" @change="getEndDate" format="yyyy-MM-dd"
          type="date" placeholder="END" test_id="end_time"></el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="3" :xl="2">
        <el-button class="hidden-md-and-down btn-md-down" @click="excelFun" type="primary">{{$t('records.export')}}</el-button>
        <el-button class="hidden-lg-and-up btn-lg-up" @click="excelFun" type="primary">{{$t('records.export')}}</el-button>
      </el-col>

    </el-row>
    <el-tabs @tab-click="getTabName" :activeName="activeName" test_id="aaaaaa">
      <el-tab-pane :key="index" v-for="(item,index) in tabs" :disabled="item.disabled" :name="item.title" :label="$t('headerCard.breadcrumb.'+item.title)">
        <component :is="item.currTab" ref="tabTable" :count="count" :search="search" :datas="datas" @totalPage-pageSize=tpData
          @pageSize="pageSize" @totalPage="totalPage" :loading="loading" :excel="excel" :item="item.label" @changed="changed" :depositThs="depositThs"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import moment from 'moment'
export default {
  props: ['params', 'loading', 'tabs', 'datas', 'count', 'number', 'activeName', 'depositThs'],
  data () {
    return {
      search: false,
      startDate: new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7),
      // endDate: new Date( // 当天23:59
      //   new Date(new Date().toLocaleDateString()).getTime() +
      //     24 * 60 * 60 * 1000 -
      //     1
      // ),
      endDate: (new Date()).getTime(), // 当前时间戳
      excel: null
    }
  },
  methods: {
    getStartDate (val) {
      this.startDate = val
      if (!this.startDate) {
        return this.openMessage('error', this.$t('errMessage.415'))
      }
      if (!this.endDate) {
        return this.openMessage('error', this.$t('errMessage.416'))
      }
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return this.openMessage('error', this.$t('errMessage.414'))
      }
      this.setPageSize()
      this.$emit('search-fun', [this.startDate, this.endDate])
    },
    getEndDate (val) {
      if (!this.startDate) {
        this.endDate = ''
        return this.openMessage('error', this.$t('errMessage.415'))
      }
      if (!this.endDate) {
        return this.openMessage('error', this.$t('errMessage.416'))
      }
      this.endDate = new Date( // 当天23:59
        new Date(new Date(this.endDate).toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      )
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return this.openMessage('error', this.$t('errMessage.414'))
      }
      this.endDate = val
      this.endDate = new Date( // 当天23:59
        new Date(new Date(this.endDate).toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      )
      this.setPageSize()
      this.$emit('search-fun', [this.startDate, this.endDate])
    },
    setPageSize () {
      let arr = this.$refs.tabTable
      for (var i in arr) {
        if (arr[i].name === this.activeName) {
          arr[i].setPageSize()
        }
      }
    },
    pageSize (type, val) {
      this.$emit('pageSize', type, val)
    },
    totalPage (type, val) {
      this.$emit('totalPage', type, val)
    },
    tpData (val) {
      console.log('[------]')
      this.$emit('totalPage-pageSize', val)
    },
    changed (val) {
      console.log(val)
      this.$emit('changed')
    },
    excelFun () {
      this.$emit('export-fun', this.activeName)
    },
    searchFun () {
      if (!this.startDate && !this.endDate) {
        return this.$emit('search-fun', 'all')
      }
      if (!this.startDate) {
        return this.openMessage('error', this.$t('errMessage.415'))
      }
      if (!this.endDate) {
        return this.openMessage('error', this.$t('errMessage.416'))
      }
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return this.openMessage('error', this.$t('errMessage.414'))
      }
      this.$emit('search-fun', [this.startDate, this.endDate])
    },
    getTabName (val) {
      let arr = this.$refs.tabTable
      this.$emit('update:activeName', val.paneName)
      this.$emit('getTabName', val.paneName)
      for (var i in arr) {
        if (arr[i].name === val.paneName) {
          arr[i].setPageSize()
        }
      }
    }
  }
}

</script>

<style lang="scss">
// @import "@/assets/scss/_variables.scss";
  .router-tab {
    padding: 20px;

    .el-tabs:not(.el-tabs--border-card) .el-tabs__item:not(.is-active) {
      color: #7d7d7d;
      font-weight: bold;
    }

    .el-tabs__item.is-active {
      font-weight: bold;
      color: $main-theme-color;

    }
    .el-tabs__active-bar.is-top{
      background-color: $main-theme-color;
    }

    .title {
      height: 30px;
      line-height: 30px;
      font-size: 20px;
      font-weight: bold;
      color: #24282d;
    }

    .el-button+.el-button {
      margin-left: 0;
    }

    .date-lg-up {
      margin-top: 10px;
      display: inline-block;
    }

    .btn-md-down {
      width: 90%;
      text-align: center;
      background: #192b57;
      border-color: #192b57;
      height: auto;
      margin-left: 10%;
    }

    .btn-md-down:hover {
      // background: #192b57;
      color: $main-theme-color;

    }

    .btn-lg-up {
      background: #192b57;
      border-color: #192b57;
      margin-top: 10px;
      display: inline-block;
    }
  }

</style>
